var map = {
	"./": 63599,
	"./az": 29686,
	"./az.json": 29686,
	"./bg": 44378,
	"./bg.json": 44378,
	"./en": 44174,
	"./en.json": 44174,
	"./fr": 94605,
	"./fr.json": 94605,
	"./index": 63599,
	"./index.js": 63599,
	"./nl": 34943,
	"./nl.json": 34943,
	"./ru": 74600,
	"./ru.json": 74600,
	"./tr": 79755,
	"./tr.json": 79755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39678;